import {assertAndContinue} from 'Asserts';
import {ContainerInfo, isWellSample, GridInfo} from 'constants/SampleConstants';
import {formatGridCoordinates} from 'samples/SampleUtil';
import {SampleDetailsWithOptionalStageRunSample} from 'workflows/util/StageRunUtil';

function getStorableLabel(storableInfo: ContainerInfo | GridInfo, preferStorableBarcode?: boolean): string {
  return preferStorableBarcode && storableInfo.barcode != null ? storableInfo.barcode : storableInfo.name;
}

export default function getSampleDetailsName(
  sampleDetails: SampleDetailsWithOptionalStageRunSample,
  preferStorableBarcode?: boolean
): string {
  if (sampleDetails.stageRunSample != null) {
    if (sampleDetails.stageRunSample.bioentity?.displayLabel != null) {
      return sampleDetails.stageRunSample.bioentity?.displayLabel;
    }
    return sampleDetails.stageRunSample.name;
  }
  if (sampleDetails.batchInfo != null) {
    return sampleDetails.batchInfo.name;
  }
  if (sampleDetails.bioentityInfo != null) {
    if (sampleDetails.bioentityInfo.displayLabel != null) {
      return sampleDetails.bioentityInfo.displayLabel;
    }
    return sampleDetails.bioentityInfo.name;
  }
  if (sampleDetails.boxInfo != null) {
    return getStorableLabel(sampleDetails.boxInfo, preferStorableBarcode);
  }
  if (sampleDetails.containerInfo != null) {
    return getStorableLabel(sampleDetails.containerInfo, preferStorableBarcode);
  }
  if (sampleDetails.textInfo != null) {
    return sampleDetails.textInfo.name ?? '';
  }
  if (sampleDetails.numberInfo != null) {
    return sampleDetails.numberInfo.name ?? '';
  }
  if (sampleDetails.booleanInfo != null) {
    return sampleDetails.booleanInfo.name ?? '';
  }

  if (isWellSample(sampleDetails)) {
    const plateLabel = getStorableLabel(sampleDetails.plateInfo, preferStorableBarcode);
    const position =
      typeof sampleDetails.position === 'string'
        ? sampleDetails.position
        : formatGridCoordinates(sampleDetails.position.rowIndex, sampleDetails.position.columnIndex);
    return `${plateLabel} / ${position}`;
  }
  if (sampleDetails.plateInfo != null) {
    return getStorableLabel(sampleDetails.plateInfo, preferStorableBarcode);
  }
  assertAndContinue(false, 'Cannot display sample details', {sampleDetails});
  return '(Unknown)';
}
